import React from 'react';

import { Flex, Statistic } from 'antd';
import { t } from 'i18next';

interface Props {
  statsList: Record<string, string | number>;
  statsTitles: string;
}

export function ModalStats({ statsList, statsTitles }: Props) {
  return (
    <Flex justify='space-between' wrap style={{ marginTop: '15px' }}>
      {
        Object.entries(statsList).map(([title, value], statIndex) => {
          const isRight = statIndex % 2 === 1;
          return (
            <Statistic
              key={title}
              style={{ width: '50%', marginBottom: '6px' }}
              title={
                <div style={{ display: 'flex', flexDirection: isRight ? 'row-reverse' : 'row' }}>
                  {t(`${statsTitles}.${title}`)}
                </div>
              }
              value={value}
              groupSeparator="" decimalSeparator=""
              valueStyle={{ fontSize: '16px', textAlign: isRight ? 'right' : 'left', overflow: 'hidden' }}
            />
          );
        })
      }
    </Flex>
  );
}

